export class AwsCassandraClusterRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsCassandraCluster",
            "baseName": "awsCassandraCluster",
            "type": "AwsCassandraClusterRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsCassandraClusterRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
